// src/firebase.js

import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";

// 1. استيراد الخدمات اللي محتاجينها
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database";
import { getFunctions, httpsCallable } from "firebase/functions"; // 🔥 1. ضيف السطر ده

// 2. ده الكود بتاعك (مظبوط 100%)
const firebaseConfig = {
  apiKey: "AIzaSyAqITuHdKJqz0KPC5vhUfD-50JYxFfyGus",
  authDomain: "orders-confirmation-2c963.firebaseapp.com",
  projectId: "orders-confirmation-2c963",
  storageBucket: "orders-confirmation-2c963.firebasestorage.app",
  messagingSenderId: "49350052043",
  appId: "1:49350052043:web:ef84416f6d2a40419eb34e",
  measurementId: "G-7R1SNH9L8P",
  databaseURL: "https://orders-confirmation-2c963-default-rtdb.europe-west1.firebasedatabase.app"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// 3. جهّز الخدمات عشان باقي التطبيق يستخدمها
export const db = getFirestore(app);
export const auth = getAuth(app);
export const rtDb = getDatabase(app); 
// const analytics = getAnalytics(app);

// --- 🔥 2. ضيف الكود الجديد من أول هنا ---

// تهيئة الـ Functions
const functions = getFunctions(app);

/**
 * بتنادي على الـ Cloud Function اللي اسمها createNewClient
 * @param {object} clientData - بيانات العميل من فورم التسجيل
 * @returns {Promise<object>} - الرد اللي جاي من الـ Function
 */
export const callCreateNewClient = async (clientData) => {
  try {
    // جهز الـ function اللي هننادي عليها
    const createNewClientFunction = httpsCallable(functions, 'createNewClient');
    
    // نادي عليها وابعتلها البيانات
    const result = await createNewClientFunction(clientData);
    
    // رجع البيانات اللي جاية من الباك إند
    return result.data;
  } catch (error) {
    // لو حصل مشكلة (زي "الإيميل موجود أصلاً")، ارمي الـ error
    console.error("Error calling createNewClient function:", error);
    // هيرمي الرسالة زي "هذا الإيميل مسجل بالفعل."
    throw new Error(error.message); 
  }
};
// --- 🔥 3. الكود الجديد خلص ---